
 <template>
  <nav id="navBarMenu" class="width50 " >
    <ul class="width100 d-flex justify-content-between align-items-center">
    
      <b-nav-item-dropdown text="آزمايشگاه ها"  id="subMenuId">
        <b-dropdown-item 
        target="_blank"
        :id="6" 
        :to="{
              name: 'galleriesFront',
              params: {id:21, slug:$root.slugGenerator('فشار') }
            }">فشار</b-dropdown-item>
        <b-dropdown-item  target="_blank"
        :id="7" 
        :to="{
              name: 'galleriesFront',
              params: {id:22, slug:$root.slugGenerator('دما') }
            }">دما</b-dropdown-item>
      </b-nav-item-dropdown>
      
      <li>
        <a 
          @click="showModalContactUs = true" 
          href="#"
          >{{$cookie.get('ltrTheme')?"ُContact us":'تماس با ما'}}
          <i class="fa fa-circle"></i>
        </a>
      </li>
      <li>
        <a 
          @click="showModalSurveyFunction" 
          href="#"
          >{{$cookie.get('ltrTheme')?"Survey":'نظرسنجي'}}
          <i class="fa fa-circle"></i>
        </a>
     </li>
      <li>
        <a 
          @click="showModal = true" 
          href="#"
          id="phone"
          >{{$cookie.get('ltrTheme')?"about us":'درباره ما'}}
          <i class="fa fa-circle"></i>
        </a>
      </li>
     <li>
          <a 
          @click="showModalPrice = true" 
          href="#"
          >{{$cookie.get('ltrTheme')?"ُServices Price":'ليست قيمت'}}
          <i class="fa fa-circle"></i>
        </a>
      </li>
      <li>
        <a target="_blank" href="https://test.mmc.ir/uploadFileFile/2983b6d0-f403-43fa-9d5c-b95499b52fbc.pdf"
          >{{$cookie.get('ltrTheme')?"Customer service":' گواهينامه'}}
          <i class="fa fa-circle"></i>
          </a> 
      </li>
      
      <!-- <li class="dropdown" :class="{ open: labMenuOpen }" @mouseleave="labMenuOpen = false" aria-haspopup="true" :aria-expanded="String(labMenuOpen)">
        <a href="#" class="dropdown-toggle" @click.prevent="toggleLabMenu" @focus="labMenuOpen = true" :title="$cookie.get('ltrTheme') ? 'calibration Labs' : 'آزمایشگاه ها'">  {{ $cookie.get('ltrTheme') ? "calibration Labs" : 'آزمایشگاه ها' }} 
           <i class="fa fa-circle"></i> 
        </a> 
        <ul class="dropdown-menu" v-show="labMenuOpen" role="menu" aria-label="Labs submenu" > 
          <li> 
             <a target="_blank" href="https://test.mmc.ir/uploadFileFile/2983b6d0-f403-43fa-9d5c-b95499b52fbc.pdf" :title="$cookie.get('ltrTheme') ? 'Customer service' : ' فشار'"
              >{{$cookie.get('ltrTheme')?"Customer service":'  فشار'}}
             <i class="fa fa-circle"></i>
             </a> 
          </li>
          <li>
            <a target="_blank" href="https://test.mmc.ir/uploadFileFile/2983b6d0-f403-43fa-9d5c-b95499b52fbc.pdf" :title="$cookie.get('ltrTheme') ? 'Lab temperatures' : 'دما'"
          >{{$cookie.get('ltrTheme')?"Customer service":' دما'}}
          <i class="fa fa-circle"></i>
          </a> 
          </li>
        </ul>
      </li> -->
    </ul>
    <b-modal
      id="aboutUsCalibrationLab"
      hide-footer
      ref="aboutUsCalibrationLab"
      v-model="showModal"
      @close="resetModal()"
      :title="
        $cookie.get('ltrTheme')
          ? 'about Us'
          : 'درباره ما'
      "
    >
      <div id="contactUsSection">
        <div
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-once="true"
          class="contactUsTitle width80 margin-auto"
        >
          <h1 class="  aos-init aos-animate" style="color: #dc143c;">
            {{
              $cookie.get("ltrTheme")
                ? "Calibration Lab "
                : "آزمايشگاه كاليبراسيون شركت مارگارين"
            }}
          </h1>
          <h3 class="blackColor04">
            {{
              $cookie.get("ltrTheme")
                ? "Respond in the shortest time"
                : "پاسخگویــــی در کمتریــــن زمــــان"
            }}
          </h3>
          <!-- <div   data-aos="zoom-in"
        data-aos-duration="15000"
        
        data-aos-once="false" class="lineBreak">
        <span></span>
        <span class="large"></span>
        <span></span>
        </div> -->
           <double-line class="hiddenInMobile width20 margin-auto" /> 
          <p class="aboutUsDescription">
          مارگارين اولين شركت توليد كننده روغن گياهي در ايران است كه با برندهای خروس، آفتاب و آفتاب طلايي در بين مردم شناخته شده است. اين شركت كه در دی ماه سال 1332 با ظرفیت تصفيه 8 تن روغن گياهي در روز پا به عرصه صنعت گذاشت و اکنون با همكاري كارشناسان مجرب توانسته است با ظرفیت توليدي 1000 تن در روز، میهمان بسیاری ازخانواده ها و صنایع مختلف کشور باشد .
          </p>
          <p class="aboutUsDescription">
            آزمايشگاه كاليبراسيون مارگارين از سال 1378 به عنوان زير مجموعه واحد برق كارخانه شروع به فعاليت كرد سپس با توجه به الزامات سازمان غذا و دارو و استاندارد هاي بين المللي نظير Codex و ISO 9001 به منظور حفظ سلامتي محصول، ايمني پرسنل و تجهيزات و با ماموريت كاليبراسيون بيش از 1000 تجهيز در سطح كارخانه براساس استاندارد هاي معتبر به عنوان يك واحد فرايندي مجزا مورد بهره برداري قرار گرفت.        
          </p>
          <p class="aboutUsDescription">به دنبال ارتقاي عمليات فني پشتيباني كننده محصولات و با توجه به پتانسيل هاي موجود از قبيل نيروي انساني ماهر و امكانات به روز ، مديريت فني كارخانه ايجاد آزمايشگاه كاليبراسيون معتبر را در دستور كار قرار داد و در سال 1402 موفق به اخذ گواهينامه ISO 17025 شد تا از اين طريق امكان ارائه خدمات كاليبراسيون به ساير ارگان ها ، كارخانجات و شركت ها فراهم گردد.</p>
          <p class="aboutUsDescription"> ما به كيفيت، دقت و انطباق با استانداردها متعهد هستيم و در راستاي ارائه خدمات كاليبراسيون با بالاترين استانداردها تلاش مي كنيم.</p>
        </div>
       
      </div>
    </b-modal>
    <b-modal
      id="servicesPriceCalibrationLab"
      hide-footer
      ref="servicesPriceCalibrationLab"
      v-model="showModalPrice"
      @close="resetModal()"
      :title="
        $cookie.get('ltrTheme')
          ? 'Services Price'
          : 'ليست قيمت'
      "
    >
    <router-link to="/loginCalibrationLab"  target="_blank"  class="btn btn-success hiddenInMobile" > {{$cookie.get('ltrTheme')?"ُSubmit Order":"ثبت سفارش"}}
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-label="Order icon" role="img">
     <path fill="currentColor" d="M3 4h2l3.6 9.59a2 2 0 0 0 2 1.41h6.72a2 2 0 0 0 1.96-1.58l1.02-4.04A2 2 0 0 0 20.7 7H6"/>
     <path fill="none" stroke="currentColor" stroke-width="2" d="M9 21a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
     <path fill="currentColor" d="M9 13l2 2l4-4" />
     </svg>
   </router-link> 
      <!-- <div id="contactUsSection"> -->
      <div v-if="items" class="mainTable">
        <table v-if="items.length > 0" class="table table-hover">
          <tr class="trHeader">
            <th>  شرح خدمات</th>
            <th>گستره</th>
            <th>توضيحات </th>
            <th>نوع</th>
            <th>قيمت</th>
          </tr>
          <tr class="trDetail" v-for="item in items" :key="item.id"  >          
            <td>
              {{ item.name_fa }}
            </td>
            <td>
              {{ item.range }}
            </td>
            <td>
              {{ item.description }}
            </td>
            <td>
              {{ item.calibrationType === 'Pressure' ? 'فشار' : (item.calibrationType === 'Temperature' ? 'دما' : '') }}
            </td>           
            <td>
              {{ item.price }}
            </td>              
          </tr>

        </table>
        <div class="noItems" v-else>
          <svg
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:osb="http://www.openswatchbook.org/uri/2009/osb"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns:ns1="http://sozi.baierouge.fr"
            id="svg2160"
            sodipodi:docname="OK-2.svg"
            viewBox="0 0 28.912 32.654"
            sodipodi:version="0.32"
            version="1.0"
            inkscape:output_extension="org.inkscape.output.svg.inkscape"
            inkscape:version="0.48.0 r9654"
          >
            <sodipodi:namedview
              id="base"
              fit-margin-left="0"
              inkscape:zoom="11"
              height="64px"
              borderopacity="1.0"
              inkscape:current-layer="layer1"
              inkscape:cx="10.569472"
              inkscape:cy="15.862443"
              fit-margin-right="2.7755576e-017"
              inkscape:grid-bbox="true"
              inkscape:window-maximized="0"
              showgrid="true"
              width="64px"
              inkscape:document-units="px"
              bordercolor="#666666"
              inkscape:window-x="137"
              inkscape:window-y="182"
              fit-margin-bottom="0"
              inkscape:window-width="1330"
              inkscape:pageopacity="0.0"
              inkscape:pageshadow="2"
              pagecolor="#ffffff"
              inkscape:window-height="900"
              fit-margin-top="0"
            />
            <g
              id="layer1"
              inkscape:label="Layer 1"
              inkscape:groupmode="layer"
              transform="translate(-20.653 -15.447)"
            >
              <path
                id="path3207"
                style="fill: #ff0000"
                inkscape:connector-curvature="0"
                d="m38.638 18.139c-1.798 1.5509-3.1446 4.3692-4.5312 5.8438-2.6315-2.177-3.8188-6.2358-6.6562-7.375-3.4407 0.91828-8.9042 4.1354-4.875 7.625 2.0576 3.0423 6.1945 5.7464 7.1562 8.9062-1.4673 3.7894-4.291 6.615-7.0312 9.375 1.3399 4.6754 7.7548 0.52478 10.344-1.75 2.0648-4.6338 3.5683 0.89824 5.4994 2.891 1.5405 6.2227 9.8042 4.4034 10.522-0.73944-2.8396-4.5489-6.7818-8.9244-9.521-13.402 1.0851-4.6542 5.6334-7.7704 6.6875-12.281-1.7893-3.1223-5.2813 0.35232-7.5938 0.90625z"
              />
              <path
                id="path3792"
                style="stroke: #a70000; fill: none"
                inkscape:connector-curvature="0"
                d="m38.638 18.139c-1.798 1.5509-3.1446 4.3692-4.5312 5.8438-2.6315-2.177-3.8188-6.2358-6.6562-7.375-3.4407 0.91828-8.9042 4.1354-4.875 7.625 2.0576 3.0423 6.1945 5.7464 7.1562 8.9062-1.4673 3.7894-4.291 6.615-7.0312 9.375 1.3399 4.6754 7.7548 0.52478 10.344-1.75 2.0648-4.6338 3.5683 0.89824 5.4994 2.891 1.5405 6.2227 9.8042 4.4034 10.522-0.73944-2.8396-4.5489-6.7818-8.9244-9.521-13.402 1.0851-4.6542 5.6334-7.7704 6.6875-12.281-1.7893-3.1223-5.2813 0.35232-7.5938 0.90625z"
              />
            </g>
            <metadata>
              <rdf:RDF>
                <cc:Work>
                  <dc:format>image/svg+xml</dc:format>
                  <dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage"
                  />
                  <cc:license
                    rdf:resource="http://creativecommons.org/licenses/publicdomain/"
                  />
                  <dc:publisher>
                    <cc:Agent rdf:about="http://openclipart.org/">
                      <dc:title>Openclipart</dc:title>
                    </cc:Agent>
                  </dc:publisher>
                  <dc:title>red not OK / failure symbol</dc:title>
                  <dc:date>2011-09-20T10:43:26</dc:date>
                  <dc:description>red not OK / failure symbol</dc:description>
                  <dc:source
                    >https://openclipart.org/detail/161515/red-not-ok--failure-symbol-by-antares42</dc:source
                  >
                  <dc:creator>
                    <cc:Agent>
                      <dc:title>Antares42</dc:title>
                    </cc:Agent>
                  </dc:creator>
                  <dc:subject>
                    <rdf:Bag>
                      <rdf:li>OK</rdf:li>
                      <rdf:li>button</rdf:li>
                      <rdf:li>failure</rdf:li>
                      <rdf:li>green</rdf:li>
                      <rdf:li>icon</rdf:li>
                      <rdf:li>not OK</rdf:li>
                      <rdf:li>red</rdf:li>
                      <rdf:li>success</rdf:li>
                    </rdf:Bag>
                  </dc:subject>
                </cc:Work>
                <cc:License
                  rdf:about="http://creativecommons.org/licenses/publicdomain/"
                >
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#Reproduction"
                  />
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#Distribution"
                  />
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#DerivativeWorks"
                  />
                </cc:License>
              </rdf:RDF>
            </metadata>
          </svg>
  
          <p>اطلاعاتی برای نمایش وجود ندارد</p>
        </div>
    </div>
    <div v-if="items != null && totalPages > 1">
      <div id="pagination">
        <pagination
          @pageChanged="pageChanged"
          :totalPages="totalPages"
          :currentPage="currentPage"
        />
      </div>
    </div>
       
      <!-- </div> -->
    </b-modal>
    <b-modal
      id="contactUsCalibrationLab"
      hide-footer
      ref="contactUsCalibrationLab"
      v-model="showModalContactUs"
      @close="resetModal()"
      :title="
        $cookie.get('ltrTheme')
          ? 'Contact Us'
          : 'تماس با ما'
      "
    >
    <div
        data-aos="zoom-in"
        data-aos-duration="2000"
        data-aos-once="true"
        class="slotElements d-flex"
      >
      <table class="table table-hover">
      <tr>
        <td>
        <contactWay
        v-if="$root.footerData"
          :title="$cookie.get('ltrTheme')?'Fax':'ارســــال فکــــس'"
          :value="$root.footerData.fax"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="60"
            height="60"
            viewBox="0 0 60 60"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.789"
                y1="1"
                x2="0.211"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#f7941e" />
                <stop offset="1" stop-color="#f0aa56" />
              </linearGradient>
            </defs>
            <g
              id="Group_2444"
              data-name="Group 2444"
              transform="translate(-1203 -731)"
            >
              <circle
                id="Ellipse_4_copy"
                data-name="Ellipse 4 copy"
                cx="30"
                cy="30"
                r="30"
                transform="translate(1203 731)"
                fill="url(#linear-gradient)"
              />
              <image
                id="Layer_2402"
                data-name="Layer 2402"
                width="25"
                height="26"
                transform="translate(1221 749)"
                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAYAAABCfffNAAAABHNCSVQICAgIfAhkiAAAAllJREFUSEtjZCAB/P//nwmovBaI04BYCovWvYyMjC7o4owk2MEAtCQLqH4qDj1/gOLaQEtuUWrJLqABrtgs+fnz520ODg4foNw3IH6CrAbDJ0DX6gEVZALxbqCr1iErBsqdBvJNsFny7du3K9zc3EFAuYdA/AvFEqBGdqAAF1TwA5DuAuISID4NtMQMKM8HkgOyPxFhiS9QzTugcmaoed+A+n4yAgWfAwUkoIK8QLoeZMmvX78usrOz2wDl90MtMSXCEm+gmrVIvn0OtEQKZMl/mNfOnj0rYGxsXAOyBOp9mCaQT8yBSk8SCC50S0D6mFAscXR0NNy7d28MExNTMbIlwEhlA0YqKCiQXYkSNWiOgscb0BJleliiPigt8Xvx4oUWMFGwoCfjz58/v9DR0ZmDHqTA4CLOJ3///pVta2vzr62tvZWYmCgDNBCU7DGAvr4+M1DNeqCEJEySaEtwpShsFqGLkWKJ4atXr1aKioryATWBig6Gf//+LQHlUWBKjAbxgcG0GYifAfkpSJkRlISJDi6F8vLyYAcHBwUfH5+FQMP+9vX1eQMNZCwoKNgCNIh58+bNcQcPHnzY2dm5jpmZWXjoBNfbt283CAgIfAO6Ogrk6g8fPuzj5OS8ByyKEgdNcEUDwxpUdl0GFt0++IoSslMXMAL/ADNb6rlz5664urruhFqCkbrIDq7169fHmJmZ7Zg4caLQvXv3+GGZC5gZWamWuojxPqlqMPIJqQYQox5mCah1oUqMBlLVAOuhB8B6yB3WkFAj1QBS1MMsUQBqYiNFIwlqfwEAu50qApI0/EQAAAAASUVORK5CYII="
              />
            </g>
          </svg>
        </contactWay>
        </td>
        <td></td>
        <td>
        <contactWay
        v-if="$root.footerData"
          :title="$cookie.get('ltrTheme')?'Mobile':'شمــــاره تــــماس'"
          value='021-35811297'
        >
        <!-- :value="$root.footerData.phone" -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="60"
            height="60"
            viewBox="0 0 60 60"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.789"
                y1="1"
                x2="0.211"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#f7941e" />
                <stop offset="1" stop-color="#f0aa56" />
              </linearGradient>
            </defs>
            <g
              id="Group_1444"
              data-name="Group 1444"
              transform="translate(-1485 -731)"
            >
              <circle
                id="Ellipse_4"
                data-name="Ellipse 4"
                cx="30"
                cy="30"
                r="30"
                transform="translate(1485 731)"
                fill="url(#linear-gradient)"
              />
              <image
                id="Layer_2399"
                data-name="Layer 2399"
                width="25"
                height="26"
                transform="translate(1503 749)"
                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAaCAYAAABCfffNAAAABHNCSVQICAgIfAhkiAAAAzZJREFUSEullm1oUmEUx3dnviwjoTBfAgU3mB+s9iFj64ObCSKYg4pBLGpQGBFBUY0W+5ARRRBFYF8iimpr9KU3myFGG2uMydoHe6MXXAOD3J1sUSsRddr/udw7rqabV4WHe55zznN+nnOfe56Hqin45XI5CVTbWPUERVGpQh+hc4q/AAAX5rcxlKw+juchgJ4LDcz3pxB4BxQbEOgh5DeQtxYEnITNDNth6DsFwH7D9zrWDhFIFJM7mHgg54oFgW0NTN2wnRMAIa7fsVZHILlEInFJLpdfhkjo//3gqIftYAWQGqyVM5DZ2dl+lUp1AuJbBNrIp2QyGVosFltgOw790Wg0eiscDr8ulVFTU5NFp9O5OTsg9QwklUr9kEqlmyGegvEsPwCC3tTr9ddgC0Kvx6LGlUoG3y88SCMDIQq/329xOp1iiK/4QQYHB7tisRjtdrsDRM9C5iEmSsEQ8m9RSCAQ6HQ4HDEYh/mLfT7ffqS/gDI85UG+LpcNfwORP7WUCQnW2to6o1AoXhZCzGZzXKPRMJmQdwLowDIQB2xnimZCIPxgnFMp/UrvpSoIgdpsNie2/N5sNvuepulu7MwrtbW1m7CBHszNzfVxWXPlzStXOZkQSEtLy26lUrkrmUx+DgaDF+12e69MJjPG4/En4+Pjj9vb2/uqyqTcMlUFIZlgFzokEsk+ksnY2JjHarX2knKRTKampvqbm5sfVQ2puFxer3dnR0dHVq1Wvyj8GBsaGj4ajcZJoaXKe/FsW7GiUbrr6upO84OxbeUkdtIn0lErLhfaxoBWqz2PQMMIpOVD2AZpwPOqSCQ6UvHump6evmEwGEgT/FasJAArYTsGm9DzhOl1zKEFyDNALkCmS0DqYTsgFILsYzgm2pjjNxQKbcGOuQ+Z9Ke84xfv6QO+7j2wteHddaXT6VXlbAAA/oyOjt5zuVwh7iJhwMJfCLR9cXHxLmq/jgSCPD8yMtKLNjKEKem869lRDofzyXCQ1dCIMBZMJlO9x+NhrkQ9PT3vIpFIGmISg9wFFBhrBRCy8P2ZdyViF8vxVLNQJiGMGYylg0gAhHEtBuH0MjYYyaLoLaZc2D+XdRXxQSHXfQAAAABJRU5ErkJggg=="
              />
            </g>
          </svg>
        </contactWay>
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
     </tr>
      <tr>
       <td>
        <contactWay
        v-if="$root.footerData"
          :title="$cookie.get('ltrTheme')?'postal Code':'کـــد پستـــی'"
          :value="$root.footerData.postal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="60"
            height="60"
            viewBox="0 0 60 60"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.789"
                y1="1"
                x2="0.211"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#f7941e" />
                <stop offset="1" stop-color="#f0aa56" />
              </linearGradient>
            </defs>
            <g
              id="Group_44444444444"
              data-name="Group 44444444444"
              transform="translate(-1203 -821)"
            >
              <circle
                id="Ellipse_4_copy_6"
                data-name="Ellipse 4 copy 6"
                cx="30"
                cy="30"
                r="30"
                transform="translate(1203 821)"
                fill="url(#linear-gradient)"
              />
              <image
                id="Layer_2708"
                data-name="Layer 2708"
                width="25"
                height="26"
                transform="translate(1221 839)"
                xlink:href="data:image/png;base64,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"
              />
            </g>
          </svg>
        </contactWay>
       </td>
       <td></td>
       <td>
        <contactWay
        v-if="$root.footerData"
          :title="$cookie.get('ltrTheme')?'E-Mail':'پـــست الکـــترونیک'"
          value="Calibration@margarineco.com"
        >
        <!-- :value="$root.footerData.email" -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="60"
            height="60"
            viewBox="0 0 60 60"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x1="0.789"
                y1="1"
                x2="0.211"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#f7941e" />
                <stop offset="1" stop-color="#f0aa56" />
              </linearGradient>
            </defs>
            <g
              id="Group_344444"
              data-name="Group 344444"
              transform="translate(-1485 -821)"
            >
              <circle
                id="Ellipse_4_copy_2"
                data-name="Ellipse 4 copy 2"
                cx="30"
                cy="30"
                r="30"
                transform="translate(1485 821)"
                fill="url(#linear-gradient)"
              />
              <image
                id="Layer_2401"
                data-name="Layer 2401"
                width="25"
                height="22"
                transform="translate(1503 841)"
                xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAWCAYAAAA1vze2AAAABHNCSVQICAgIfAhkiAAAA0FJREFUSEtjZICC////8wGZIjA+hfQbRkbGTzAzGIGGCwI5C4DYF4gZKTQc7mYgYxMQJwAt+wCyBGRBPJUMRzdmPtCSJJAlb4EyQiDZHz9+3OTg4FAFMpnItPQf0IxbQDM0QPr//fv3gZmZWRhkyX+QwJ8/f17x8PDY7dq1y8XGxqabiYmJkxSLgAZ+P3LkSKmbm9ueL1++HGJhYRED6Qf6RBJuCUjg1atXa52cnCry8/O1EhMTZwAVShJjEdCBr5cvX55RXl5+/ezZs7WSkpKR8EhnZFRBsQQqcWTZsmUxQMXSzc3Ns7i4uLTxWQQK4sbGxozbt29/WbBgwSRgaFgiqwf6RB2bJSA1d+7duxeUnJz8f/369RMEBAScsVn06dOnw2FhYQVWVlaCFRUVM9jY2FTQ1eGzBKT23devX8NERETuXLt2rURRUTEH2YDnz58v0tXV7Zg+fbpeUFDQVFAEY3MIIUtAen79/fs3ERg3By5cuJCsp6dXBxK8dOlSk4GBwcrjx497m5ubdwANYsMVpAQtAVrw6s6dO97q6upX+fj4uFesWOEDMgzo8uPa2trsTU1N/N7e3iuBQjgTCF5Lfv369WzChAkJQNe+W7169RSgb55mZ2fnHDhwQPjQoUNt/Pz8MkAxt/3790tYW1tvBcaHPEnB9fPnz3vV1dWJ79+//z1t2rQ57OzsWlADrgPzAyMwD4EzGxBcBAadD9CHsvX19YuB6pSJinhgkryWmZmZDEyKzD09PfOBGkElAD5w/+nTpx5VVVXcwEQwH5jk9fEm4W/fvl1KSkpK0dTU5AVqms/KyipHwAKY9KO3b996xMbGMq5cuXIuLy+vBUwCJU6AkfzWwcHBOSYmRi4lJWUuMEmKEmkBTNlLoCM9fXx8vu3evfsoLEnDLAEXkMAi7O+LFy9WiIuLewPDXIBEC2DK3wPjbAVQfypQgAXo8I/AxGEGyvHzgAKJZBqKVxuoLAQ6ugpkicDHjx9XApOkC1AHuUU8umX/Pnz4sDc+Pr5q06ZN72E1oYSLi4ukra0tuF6hFBw7duz9zp07v0DN+QizBOQDCSDmodQCNP0gi16g1+kgy5ipZNFfoDn/QGYBAEw8bmdwmZOrAAAAAElFTkSuQmCC"
              />
            </g>
          </svg>
        </contactWay>
       </td>
      </tr>
      </table>
      </div>
    </b-modal>
    <b-modal
      id="surveyCalibrationLab"
      hide-footer
      ref="surveyCalibrationLab"
      v-model="showModalSurvey"
      @close="resetModal()"
      :title="
        $cookie.get('ltrTheme')
          ? 'ُSurvey'
          : 'نظرسنجي'
      "
    >
      <div id="contactUsSection">
        <div
          data-aos="zoom-in"
          data-aos-duration="1000"
          data-aos-once="true"
          class="contactUsTitle width80 margin-auto"
        >
          <h1 class="blackColor06">
            {{
              $cookie.get("ltrTheme")
                ? "Sending a message to the management"
                : "نظرسنجي آزمايشگاه كاليبراسيون"
            }}
          </h1>
          <double-line class="hiddenInMobile width20 margin-auto" />
        </div>
        <div
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-once="true"
          id="contactUsForm"
          class="width80 margin-auto"
        >
          <div id="formTop" class="width100 d-flex justify-content-end">
            <div
              class="contactUsInput d-flex justify-content-end align-items-center"
            >
              <p v-if="!writeOrderNumber" @click="showSection('writeOrderNumber', true)">
                <span class="blackColor06">{{
                  $cookie.get("ltrTheme") ? "Order number" : "شماره سفارش"
                }}</span>
                <span class="blackColor06" v-if="orderNumber">{{ orderNumber }}</span>
              </p>
              <input
                @keydown.enter.tab="showSection('writeFullName', true)"
                id="writeOrderNumber"
                v-model="orderNumber"
                v-else
                @blur="writeOrderNumber = false"
                type="number"
              />
              <!-- <svg
                width="25"
                version="1.1"
                id="Order"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 297 297"
                style="enable-background: new 0 0 297 297"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M108.66,51.642c16.03,0,29.073,13.044,29.073,29.077c0,5.53,4.483,10.013,10.013,10.013
		c5.529,0,10.013-4.482,10.013-10.013c0-27.074-22.025-49.104-49.099-49.104c-5.529,0-10.013,4.482-10.013,10.014
		C98.648,47.157,103.13,51.642,108.66,51.642z"
                  />
                  <path
                    d="M108.659,20.026c33.465,0.002,60.69,27.229,60.69,60.692c0,5.53,4.483,10.013,10.013,10.013
		c5.53,0,10.014-4.482,10.014-10.013c0-44.506-36.209-80.717-80.716-80.719c-5.529,0-10.013,4.482-10.013,10.013
		C98.648,15.544,103.13,20.026,108.659,20.026z"
                  />
                  <path
                    d="M273.714,238.342l-68.719-68.721c-1.877-1.877-4.424-2.934-7.08-2.934c-2.656,0-5.202,1.057-7.08,2.934l-30.273,30.27
		c-7.895-5.509-15.892-12.236-23.379-19.725c-7.49-7.49-14.218-15.486-19.727-23.382l30.273-30.271c3.91-3.91,3.91-10.25,0-14.161
		L79.009,43.629c-1.878-1.877-4.424-2.932-7.08-2.932c-2.656,0-5.203,1.055-7.08,2.932l-34.36,34.363
		c-13.311,13.31-13.517,36.962-0.578,66.599c11.665,26.716,32.887,56.229,59.754,83.099c26.866,26.866,56.377,48.088,83.093,59.753
		c14.597,6.374,27.74,9.558,38.913,9.558c11.512,0,20.93-3.381,27.685-10.137l34.359-34.36
		C277.624,248.593,277.624,242.253,273.714,238.342z M71.929,64.871l54.56,54.562l-20.2,20.2l-54.56-54.562L71.929,64.871z
		 M180.771,269.089c-24.479-10.689-51.806-30.421-76.945-55.561c-25.142-25.143-44.873-52.471-55.563-76.952
		c-6.075-13.914-8.705-25.912-7.77-34.418l51.592,51.593c7.236,13.539,17.901,27.54,30.938,40.574
		c13.029,13.03,27.027,23.697,40.57,30.937l51.596,51.597C206.684,277.795,194.687,275.165,180.771,269.089z M232.275,265.623
		l-54.56-54.561l20.2-20.2l54.559,54.562L232.275,265.623z"
                  />
                </g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg> -->
            </div>
            <div
              class="contactUsInput d-flex justify-content-end align-items-center"
            >
              <p
                v-if="!writeFullName"
                @click="showSection('writeFullName', true)"
              >
                <span class="blackColor06">{{
                  $cookie.get("ltrTheme") ? "Full Name" : "نام و نام خانوادگی"
                }}</span>
                <span class="blackColor06" v-if="fullName">{{ fullName }}</span>
              </p>
              <input
                id="writeFullName"
                v-else
                v-model="fullName"
                @blur="writeFullName = false"
                type="text"
              />

              <svg
                width="26"
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 60 60"
                style="enable-background: new 0 0 60 60"
                xml:space="preserve"
              >
                <path
                  d="M48.014,42.889l-9.553-4.776C37.56,37.662,37,36.756,37,35.748v-3.381c0.229-0.28,0.47-0.599,0.719-0.951
	c1.239-1.75,2.232-3.698,2.954-5.799C42.084,24.97,43,23.575,43,22v-4c0-0.963-0.36-1.896-1-2.625v-5.319
	c0.056-0.55,0.276-3.824-2.092-6.525C37.854,1.188,34.521,0,30,0s-7.854,1.188-9.908,3.53C17.724,6.231,17.944,9.506,18,10.056
	v5.319c-0.64,0.729-1,1.662-1,2.625v4c0,1.217,0.553,2.352,1.497,3.109c0.916,3.627,2.833,6.36,3.503,7.237v3.309
	c0,0.968-0.528,1.856-1.377,2.32l-8.921,4.866C8.801,44.424,7,47.458,7,50.762V54c0,4.746,15.045,6,23,6s23-1.254,23-6v-3.043
	C53,47.519,51.089,44.427,48.014,42.889z"
                />
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
                <g></g>
              </svg>
            </div>
          </div>
          <!-- <s-table
                    v-model="itemsQuestion"
                    @showModal="showModalSurvey"
                    @deleteItem="deleteItem"
                    :settings="settings"
                    :headers="headers"
                  /> -->
          <div v-if="itemsQuestion" class="mainTable">
        <table v-if="itemsQuestion.length > 0" class="table table-hover">
          <tr class="trHeader">
            <th>سوال</th>
            <th>امتياز (0 تا 20) </th>
            <th>توضيحات</th>
          </tr>
          <tr class="trDetail" v-for="item in itemsQuestion" :key="item.id"  >          
            <td>
              {{ item.title_fa }}
            </td>
            <td>
              <!-- {{ item.priority }} -->
              <!-- <input type="number"  class="text-center" v-model="item.priority"  placeholder="امتياز را وارد نماييد." /> -->
              <select id="priority" v-model="item.priority">
                 <option v-for="opt in selectPriority" :key="opt.id" :value="opt.id" >
                 {{ opt.label }}
                 </option>
                </select>
                <p>{{ selectedPriority }}</p>
            </td>
            <td>
                <!-- {{ item.description }} -->
                <input type="text" class="text-center" v-model="item.description"  placeholder="توضيحات را وارد نماييد." />
            </td>             
          </tr>

        </table>
        <div class="noItems" v-else>
          <svg
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:osb="http://www.openswatchbook.org/uri/2009/osb"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns:ns1="http://sozi.baierouge.fr"
            id="svg2160"
            sodipodi:docname="OK-2.svg"
            viewBox="0 0 28.912 32.654"
            sodipodi:version="0.32"
            version="1.0"
            inkscape:output_extension="org.inkscape.output.svg.inkscape"
            inkscape:version="0.48.0 r9654"
          >
            <sodipodi:namedview
              id="base"
              fit-margin-left="0"
              inkscape:zoom="11"
              height="64px"
              borderopacity="1.0"
              inkscape:current-layer="layer1"
              inkscape:cx="10.569472"
              inkscape:cy="15.862443"
              fit-margin-right="2.7755576e-017"
              inkscape:grid-bbox="true"
              inkscape:window-maximized="0"
              showgrid="true"
              width="64px"
              inkscape:document-units="px"
              bordercolor="#666666"
              inkscape:window-x="137"
              inkscape:window-y="182"
              fit-margin-bottom="0"
              inkscape:window-width="1330"
              inkscape:pageopacity="0.0"
              inkscape:pageshadow="2"
              pagecolor="#ffffff"
              inkscape:window-height="900"
              fit-margin-top="0"
            />
            <g
              id="layer1"
              inkscape:label="Layer 1"
              inkscape:groupmode="layer"
              transform="translate(-20.653 -15.447)"
            >
              <path
                id="path3207"
                style="fill: #ff0000"
                inkscape:connector-curvature="0"
                d="m38.638 18.139c-1.798 1.5509-3.1446 4.3692-4.5312 5.8438-2.6315-2.177-3.8188-6.2358-6.6562-7.375-3.4407 0.91828-8.9042 4.1354-4.875 7.625 2.0576 3.0423 6.1945 5.7464 7.1562 8.9062-1.4673 3.7894-4.291 6.615-7.0312 9.375 1.3399 4.6754 7.7548 0.52478 10.344-1.75 2.0648-4.6338 3.5683 0.89824 5.4994 2.891 1.5405 6.2227 9.8042 4.4034 10.522-0.73944-2.8396-4.5489-6.7818-8.9244-9.521-13.402 1.0851-4.6542 5.6334-7.7704 6.6875-12.281-1.7893-3.1223-5.2813 0.35232-7.5938 0.90625z"
              />
              <path
                id="path3792"
                style="stroke: #a70000; fill: none"
                inkscape:connector-curvature="0"
                d="m38.638 18.139c-1.798 1.5509-3.1446 4.3692-4.5312 5.8438-2.6315-2.177-3.8188-6.2358-6.6562-7.375-3.4407 0.91828-8.9042 4.1354-4.875 7.625 2.0576 3.0423 6.1945 5.7464 7.1562 8.9062-1.4673 3.7894-4.291 6.615-7.0312 9.375 1.3399 4.6754 7.7548 0.52478 10.344-1.75 2.0648-4.6338 3.5683 0.89824 5.4994 2.891 1.5405 6.2227 9.8042 4.4034 10.522-0.73944-2.8396-4.5489-6.7818-8.9244-9.521-13.402 1.0851-4.6542 5.6334-7.7704 6.6875-12.281-1.7893-3.1223-5.2813 0.35232-7.5938 0.90625z"
              />
            </g>
            <metadata>
              <rdf:RDF>
                <cc:Work>
                  <dc:format>image/svg+xml</dc:format>
                  <dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage"
                  />
                  <cc:license
                    rdf:resource="http://creativecommons.org/licenses/publicdomain/"
                  />
                  <dc:publisher>
                    <cc:Agent rdf:about="http://openclipart.org/">
                      <dc:title>Openclipart</dc:title>
                    </cc:Agent>
                  </dc:publisher>
                  <dc:title>red not OK / failure symbol</dc:title>
                  <dc:date>2011-09-20T10:43:26</dc:date>
                  <dc:description>red not OK / failure symbol</dc:description>
                  <dc:source
                    >https://openclipart.org/detail/161515/red-not-ok--failure-symbol-by-antares42</dc:source
                  >
                  <dc:creator>
                    <cc:Agent>
                      <dc:title>Antares42</dc:title>
                    </cc:Agent>
                  </dc:creator>
                  <dc:subject>
                    <rdf:Bag>
                      <rdf:li>OK</rdf:li>
                      <rdf:li>button</rdf:li>
                      <rdf:li>failure</rdf:li>
                      <rdf:li>green</rdf:li>
                      <rdf:li>icon</rdf:li>
                      <rdf:li>not OK</rdf:li>
                      <rdf:li>red</rdf:li>
                      <rdf:li>success</rdf:li>
                    </rdf:Bag>
                  </dc:subject>
                </cc:Work>
                <cc:License
                  rdf:about="http://creativecommons.org/licenses/publicdomain/"
                >
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#Reproduction"
                  />
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#Distribution"
                  />
                  <cc:permits
                    rdf:resource="http://creativecommons.org/ns#DerivativeWorks"
                  />
                </cc:License>
              </rdf:RDF>
            </metadata>
          </svg>
  
          <p>اطلاعاتی برای نمایش وجود ندارد</p>
        </div>
    </div>
          <!-- <div id="formBottom">
            <textarea
              id="bodyMessage"
              :placeholder="
                $cookie.get('ltrTheme')
                  ? 'Criticisms and Suggestions'
                  : 'انتقادات و پيشنهادات'
              "
              v-model="description"
              cols="30"
              rows="2"
            ></textarea>
          </div> -->
          <rounded-button
              :class="{ disableButton: disabled }"
              @buttonClicked="submitSurvey()"
              :type="'button'"
              :buttonType="'button'"
              :title="
                $cookie.get('ltrTheme')
                  ? 'Submit Survey'
                  : 'ثبت نظرسنجي'
              "
            />
        </div>
      </div>
    </b-modal>
  </nav>
  
</template> 
<script>
//import { BModal } from "bootstrap-vue";
import {
  required,
  minLength,
  maxLength,
 // between
} from "vuelidate/lib/validators";
  import pagination from "@/components/front/shared/pagination.vue";
  import SInputs from "@/components/admin/shared/sInputs.vue";
  import STable from "@/components/admin/shared/sTable.vue";
  import adminMixin from "@/libraries/adminController.js";
  import { BModal, BButton, BOverlay, BSpinner ,BNavItemDropdown,BDropdownItem } from "bootstrap-vue";
  import contactWay from "@/components/front/contactUs/contactWay.vue";
  import RoundedButton from "@/components/front/shared/roundedButton.vue";
  import DoubleLine from "@/components/front/shared/doubleLine.vue";
 // import router from "../../router";
export default {
  mixins: [adminMixin],
  components: {
    SInputs,
      BModal,
      BButton,
      STable,
      BOverlay,
      BSpinner,
      pagination,
      contactWay,
      BNavItemDropdown,BDropdownItem,//router
      RoundedButton,DoubleLine
  },
  methods: {
    submitSurvey() {
      if (this.$v.fullName.required == false) {
        return this.$toast.error("وارد کردن نام الزامی است");
      } else if (this.$v.fullName.minLength == false) {
        return this.$toast.error("نام کامل شما باید بیش از شش حرف باشد");
      } else if (this.$v.orderNumber.required == false) {
        return this.$toast.error("وارد کردن شماره سفارش الزامی است");
      } //else if (
      //  this.$v.mobile.minLength == false ||
       // this.$v.mobile.minLength == false
      //) {
      //  return this.$toast.error("شماره موبایل شامل 11 رقم است");

      //this.showRecaptcha=true;
      this.$axios.post(`CalibrationLabSurvey/ValidOrderNumber?orderNumber=${this.orderNumber}`).then((response) => {
        //debugger;
        this.validOrderNumber = response.data.data;//
       });
       if( this.validOrderNumber == false)
       {
        return this.$toast.error("شماره سفارش نامعتبر مي باشد.");
       }
       //------------------------------
      const pack = {
        fullName: this.fullName,
        orderNumber : this.orderNumber,
        questionSurveyId: this.mobile,
        priority: this.text,
        description:false,
      };
     // this.disabled=true;
   var CountItems=0;
   var CountRow=0;
   var UnValidPriority=0;
  // var CountBetween=0;
   for(let item in this.itemsQuestion)
    {
    //  debugger;
      CountRow ++;
      if(this.itemsQuestion[item].priority != null ){
        CountItems ++;
      }
      if(this.itemsQuestion[item].priority < 0 || this.itemsQuestion[item].priority  >20 ){
        UnValidPriority ++;
      }
      // if(this.$v.itemsQuestion[item].priority.between == false){
      //   CountBetween ++;
      // }
    }
    if (CountRow != CountItems )
    {
      return this.$toast.error("وارد کردن امتياز الزامی است");
    //  this.disabled = true;
    }
    if(UnValidPriority != 0)
    {
     return this.$toast.error("امتياز بايد بين 0 تا 20 وارد شود.");
    }
   //------------------------------------------
   var Counts=0;
    for(let item in this.itemsQuestion)
    {
      if(this.itemsQuestion[item].priority != null )
      {
        Counts ++;
      let pack = {
        fullName: this.fullName,
        orderNumber : this.orderNumber,
        questionSurveyId: this.itemsQuestion[item].id,
        priority: this.itemsQuestion[item].priority,
        description:this.itemsQuestion[item].description,
      };
      this.disabled = true;
       this.$axios
        .post("CalibrationLabSurvey/CreateCalibrationLabSurvey", JSON.stringify(pack), {
          headers: {
            // Overwrite Axios's automatically set Content-Type
            "Content-Type": "application/json",
          },
        })
        .catch((error) => {
          this.disabled = false;
          let arrayError = error.response.data.message.split("|");
          arrayError.forEach((err, index) => {
            if (index < 1) {
              this.$toast.error(err, {
                timeout: 1000 * (index + 4),
                pauseOnHover: true
              });
            }
          });
        });
       
      }}
        if(Counts == CountItems){
          this.$toast.success(".ثبت با موفقیت انجام گرديد");
          this.resetModal();
          this.loadItems(this.currentPage);
         }
      //--------------------------------------------
  
      },
    showEditModal(item) {

      this.editedId = item.id;
       this.$axios.get(`${this.apiRoute}/${item.id}`).then((response) => {
         this.item = response.data.data;//
         this.convertToBigData(response.data.data);
       });
      this.editModel = true;
    },
    showModalFunction() {
        this.showModalPrice = true;
        setTimeout(() => {
          document
            .getElementById("blogModal___BV_modal_content_")
            .removeAttribute("tabindex");
        });
      },
     showModalSurveyFunction() {
        this.showModalSurvey = true;
       this.$axios.get("CalibrationLabQuestionSurvey").then((res) => {
        //this.$axios.get(`${this.apiRoute}/${item.id}`).then((response) => {
        this.itemsQuestion = res.data.data;
       //this.showModal = true;
       });
        setTimeout(() => {
          document
            .getElementById("blogModal___BV_modal_content_")
            .removeAttribute("tabindex");
        });
      },
    changeLanguage() {
      if (!this.$cookie.get("ltrTheme")) {
        this.$cookie.set("ltrTheme", "true");
        this.$axios.defaults.headers.common["Accept-Language"] = "en";
      } else {
        this.$cookie.delete("ltrTheme");
        this.$axios.defaults.headers.common["Accept-Language"] = "fa";
      }
      this.$router.go(0);
    },
    showSection(section, flag) {
      if (flag == true) {
        this[section] = true;
      }
      setTimeout(() => {
        document.getElementById(section).focus();
      }, 500);
    },
   
    resetModal() {
      this.showModal = false;
      this.showModalPrice = false;
      this.showModalContactUs=false;
      this.showModalSurvey=false;
      this.fullName="";
      this.orderNumber="";
    },
    toggleMenu() {
      this.showMenuModal = !this.showMenuModal;
    },
   // exitSearch(flag) {
     // this.showSearch = flag;
    //},
  },
  data() {
    return {
      //showSearch: false,
      //showMenuModal: false,
      selectPriority: Array.from({ length: 21 }, (_, i) => ({id: String(i),label: String(i) })),
      validOrderNumber:false,
      disabled: false,
      showModal: false,
      showModalPrice:false,
      showModalContactUs:false,
      showModalSurvey:false,
      itemsQuestion :null,
      description:"",
      fullName: "",
      orderNumber:"",
      writeFullName: false,
      writeOrderNumber:false,
      //labMenuOpen: false,
      headers: [
          {
            style: "col-12",
            show_in_table: false,
            show_in_Form: false,
           // placeholder: " شرح خدمات را وارد کنید",
            type: "number",
            multiData: true,
            name: "سوال",
            key: "id"
          },
          {
            style: "col-6",
            show_in_table: true,
            show_in_Form: true,
           // placeholder: " شرح خدمات را وارد کنید",
            type: "string",
            multiData: true,
            name: "سوال",
            key: "title"
          },
          {
            style: "col-12",
            show_in_table: false,
            show_in_Form: true,
            placeholder: "شماره سفارش را وارد کنید",
            type: "string",
            multiData: true,
            name: "شماره سفارش",
            key: "orderNumber"
          },
          {
            style: "col-12",
            show_in_table: false,
            show_in_Form: true,
            placeholder: " نام و نام خانوادگي راوارد کنید",
            type: "string",
            multiData: true,
            name: "نام و نام خانوادگي",
            key: "fullName"
          },
          {
            style: "col-6",
            show_in_table: true,
            placeholder: "امتياز (0 تا 20) را وارد کنید",
            type: "number",
            multiData: true,
            name: "امتياز",
           // selectIN: "selectListType",
            key: "priority"
          },
          {
            style: "col-12",
            show_in_table: true,
            placeholder: "توضيحات را انتخاب کنید",
            type: "string",
            multiData: false,
            name: "توضيحات",
            multiple: false,
           // selectIN: "selectListType",
            key: "description"
          }
        //  , {
        //     style: "col-12",
        //     show_in_table: false,
        //     show_in_Form: false,
        //     placeholder: "",
        //     type: "setting",
        //     name: "تنظیمات",
        //     multiData: false,
        //     key: "",
        //   //  innerRoute: "/admin-panel/product-feature",
        //   //  edit: true,
        //     delete: false,
        //     editLabel: "ویرایش"
        //   }
        ],
       pageSize: 10,
        bigData: {
          persian: {},
          english: {},
          both: {}
        },
        title: " آزمايشگاه كاليبراسيون",
         editedId: null,
         apiRoute: "CalibrationLab",
    };
  },
  watch: {
      item(newVal) {
        this.bigData = newVal;
      }
    },
  computed: {
    // menu() {
    //   return this.$store.getters.getMenus;
    // },
    // utilityLink() {
    //   return this.$store.getters.getUtilityLinks;
    // },
    // brands() {
    //   this.$store.getters.getBrands;
    // },
  },
  mounted() {
      if (this.$route.query.page) {
        this.currentPage = this.$route.query.page;
      } else {
        this.currentPage = 1;
      }
      // this.loadSettings([{ route: "ProductCategory", field: "name" },{ route: "Brand", field: "title" },{ route: "UnitProduct", field: "title" }]);
  
       // this.settings['selectListType']=[ {id:'1',label:'فشار'}, {id:'2',label:'دما'}]
      this.loadItems();
     // this.getId();
    },
    validations: {
    fullName: {
      required,
      minLength: minLength(5)
    },
    orderNumber:{
      required,
    },
    // text: {
    //   required,
    //   minLength: minLength(20)
    // },
    priority: {
      required,
      //between: between(0, 20)
    }
  },
};
</script>


<style scoped>
 .slotElements{
  width: 100% !important;
  direction: rtl;
}
@media (max-width: 1000px){
 .slotElements{
  width: 100% !important;
}
}
.aboutUsDescription{
  font-size: 18px;text-align: right;
  direction: rtl;
}
#healthAmbassador #headerContent #navBarMenu ul li a {
  font-family: "yekan-bold";
  font-size: 17px;
  color: white;
  /* padding: 15px; */
}
#healthAmbassador #navBarMenu ul {
  margin-bottom: 0;
  padding: 0;
}
#healthAmbassador #navBarMenu {
  width: 50%;
  background: #0000001f;
  padding: 0;
  border-radius: 30px;
}
#homeSection #homeLeader #headerContent #navBarMenu ul {
  border-radius: 30px !important;
}
/* 
#homeSection #homeLeader #headerContent #navBarMenu ul {
  margin: 0 !important;
  margin-left: 0px !important;
  background: #0000001f!important;
  border-radius: 10px !important;
}
 #navBarMenu ul {
  margin: 0;
  margin-left: 1px !important; 
  background: #0000001f;
  border-radius: 0px !important;
} 
#subMenuId li {

  margin-right: 20px !important;
  background: #0000001f;
  border-radius: 0px !important;
} */

/* .majma:hover 
{
  color: red !important ;
  }
#navBarMenu important {
  width: 60%;
} */
</style> 
